import { Dispatch, SetStateAction, createContext } from 'react';
import { DEFAULT_MODAL_CONTENT } from '../utils/constants';
import { ModalAttributes } from 'data_types/modal';

export const ModalContext = createContext({
    options: DEFAULT_MODAL_CONTENT,
    setOptions: (null as unknown) as Dispatch<SetStateAction<ModalAttributes>>,
});
